import { app } from '../../../../bootstrap/core';
import { transferringClosedState, transferringClosedStateName, receivingClosedState, receivingClosedStateName } from './closed.state';
import { closedComponent } from './closed.component';

app.config(transferringClosedState);
app.config(receivingClosedState);
app.constant('transferringClosedStateName', transferringClosedStateName);
app.constant('receivingClosedStateName', receivingClosedStateName);
app.component(closedComponent.name, closedComponent);
